"use client"

import { useSidebar } from "@/components/ui/sidebar"
import { SidebarIcon } from "./icons"

type Team = {
  name: string
  logo: React.ComponentType<React.SVGProps<SVGSVGElement>>
  plan: string
}

type TeamSwitcherProps = {
  teams: Team[]
}

export function TeamSwitcher({ teams }: TeamSwitcherProps) {
  const { toggleSidebar } = useSidebar()

  return (
    <div className="flex items-center gap-2 px-2 py-3">
      <button
        onClick={toggleSidebar}
        className="group relative shrink-0 cursor-pointer size-5"
        aria-label="Toggle Sidebar"
      >
        <img 
          src="/img/logo.png" 
          alt="Logo" 
          className="size-5 object-contain shrink-0 invert dark:invert-0 transition-opacity group-hover:opacity-0" 
        />
        <SidebarIcon className="size-4 absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity" />
      </button>
    </div>
  )
}

